import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'button[cmpsCoachingOppItemButton], a[cmpsCoachingOppItemAnchor]',
    template: ` <cmps-coaching-opp-item
        [label]="label"
        [goalBorderColour]="goalBorderColour"
        [goalColour]="goalColour"
        [goalLabel]="goalLabel"
        [goalLabelColour]="goalLabelColour"
        [goalIcon]="goalIcon"
        [goalBadgeColour]="goalBadgeColour"
        [goalBadgeLabel]="goalBadgeLabel"
        [goalBadgeLabelColour]="goalBadgeLabelColour"
        [targetColour]="targetColour"
        [targetLabel]="targetLabel"
        [active]="active"
    ></cmps-coaching-opp-item>`,
    host: {
        class: 'cmps-coaching-opportunity-item-action',
        '[class.cmps-coaching-opportunity-item-action--button]':
            '_el.nativeElement.tagName.toLowerCase() === "button"',
        '[class.cmps-coaching-opportunity-item-action--anchor]':
            '_el.nativeElement.tagName.toLowerCase() === "a"',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsOpportunityItemActionComponent {
    @Input() label: string;
    @Input() goalBorderColour: string;
    @Input() goalColour: string;
    @Input() goalLabel: string;
    @Input() goalLabelColour: string;
    @Input() goalIcon: string;
    @Input() goalBadgeColour: string;
    @Input() goalBadgeLabel: string;
    @Input() goalBadgeLabelColour: string;
    @Input() targetColour: string;
    @Input() targetLabel: string;
    @Input() active: boolean;

    constructor(/** @private */ public readonly _el: ElementRef<HTMLElement>) {}
}
